export async function sendEmail({
    recipientEmail,
    senderEmail,
    subject,
    content,
    senderName = null,
    replyTo = null,
    attachments = null,
    sendSeparately = false,
}) {
    try {
        // Validate required fields
        if (!recipientEmail || !senderEmail || !subject || !content) {
            throw new Error('Missing required email fields');
        }

        // Split recipientEmail by comma or semicolon and trim whitespace
        const recipients = recipientEmail;


        const formData = new FormData();

        // Build input object, only add senderName and replyTo if present
        const input = {
            recipientEmails: recipients,
            senderEmail : senderEmail,
            subject : subject,
            content : content,
            sendSeparately : sendSeparately,
        };
        if (senderName) input.senderName = senderName;
        if (replyTo) input.replyTo = replyTo;

        // const jsonData = { input };

        // Remove debug log
        // const jsonString = JSON.stringify(jsonData);
        // console.log('Sending email with data:', jsonString);

        formData.append('data', JSON.stringify(input));

        // Add any attachments if they exist
        if (attachments) {
            attachments.forEach((file, index) => {
                formData.append('files', file);
            });
        }

        // Send the request (do NOT set Content-Type header)
        const response = await fetch(`${process.env.REACT_APP_EMAIL_SERVER_URL}/global/send-email`, {
            method: 'POST',
            body: formData,
            mode: 'cors',
        });

        if (!response.ok) {
            let errorMsg = '';
            try {
                const errorData = await response.json();
                errorMsg = JSON.stringify(errorData);
                console.log('Error response:', errorMsg);
            } catch (e) {
                errorMsg = await response.text();
            }
            throw new Error(`HTTP error! status: ${response.status} ${errorMsg}`);
        }
        return await response.json();
    } catch (error) {
        console.error('Error sending email:', error);
        throw error;
    }
}

